import { CommandArray } from "./commandArray";
import { ComponentBase, Components } from "./types";
import { cookieUtil, logUtil } from "@repo/lib-common";
import { domReadyStateCompleteSubject } from "../eventSubjects/domReadyStateCompleteSubject";
import { domContentLoadedSubject } from "../eventSubjects/domContentLoadedSubject";

export type ExistingPrimitiveTagType = { cmd: [] };
export type DomainTagGlobalType = DomainTag | ExistingPrimitiveTagType | undefined
export class DomainTag {

    constructor() {
        domReadyStateCompleteSubject.subscribe(() => {
            this.cmd.canProcess = true;
            this.processQueue();
        })
        domContentLoadedSubject.subscribe(() => {
            this.cmd.canProcess = true;
            this.processQueue();
        });
    }

    cmd: CommandArray = new CommandArray();
    components: Components = {};
    addComponent<T extends ComponentBase>(c: T): void {

        if (this.components[c.key]) {
            logUtil.consoleWarn("another service already exists with same key:", c);
        }
        this.components[c.key] = c;
        logUtil.consoleLog("adding a new service finished", c);
    }
    get(key: string): ComponentBase {
        const srv = this.components[key];
        return srv;
    }
    processQueue(): void {
        this.cmd.processQueue();
    }
    isInitialized: boolean = false;
    isRegen: boolean = false;

    doesCookieExists = cookieUtil.cookieHelper.doesCookieExists;



}


